import { openLity } from "../utils/utils";
import { renderEmbedVidyardPlayer } from '../api/media/vidyard';

/*
* Videos
*/

const setLightBoxOnYoutubeLinks = () => {
    const linktoVideos = document.querySelectorAll("a[href*='youtube.com/watch?v='], a[href*='/youtu.be/'], a[data-href*='youtube.com/watch?v='], a[data-href*='/youtu.be/']");

    for ( let i = 0; i < linktoVideos.length; i++ ){
        if(!linktoVideos[i].dataset.href) {
            linktoVideos[i].setAttribute('data-lity','');
        }

        if ( linktoVideos[i].childElementCount === 1 && linktoVideos[i].children[0].tagName === "IMG" ){
            linktoVideos[i].classList.add('has-video-thumbnail');
            linktoVideos[i].innerHTML +=  "<div class=\"icon_info\"><i class=\"icon play\"></i></div>";
        }
    }
};

const setVideoWaypoints = () => {
    const $videosTriggeredInViewport = $('[data-play-in-viewport]');

    $videosTriggeredInViewport.each((index, videoElement) => {
        triggerOnWaypoint(videoElement, '60%');
        triggerOnWaypoint(videoElement, '10%');
    });
};

const triggerOnWaypoint = (videoElement, offset) => {
    new Waypoint({
        element: videoElement,
        handler: () => {
            if (!videoElement.paused) {
                videoElement.pause();
            } else {
                videoElement.play();
            }
        },
        offset: offset
    });
};

const renderVidyardEmbedPlayers = () => {
    const $vidyardVideos = $('.vidyard-player-embed:not([data-video-player])');

    $vidyardVideos.each((index, vidyardVideo) => {
        if (!$(vidyardVideo).find('img').length) {
            renderEmbedVidyardPlayer({
                container: vidyardVideo,
                code: $vidyardVideos.data('uuid')
            });
        }
    });
};

const videos = () => {
    setVideoWaypoints();
    renderVidyardEmbedPlayers();
    setLightBoxOnYoutubeLinks();
    openLity();
};

export {videos};
